export class AlfatronMuheGen2 {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.videoOutputs = Array(17).fill('1');
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /r fw version!/i,
                callback: (match) => {
                    this.socket.send('MCU BOOT:V1.03.04');
                    this.socket.send(`MCU APP :V1.33.02`);
                    this.socket.send('SUB1 APP :V1.03.09');
                    this.socket.send('SUB2 APP :V1.00.04');
                    this.socket.send('CPLD APP :V1.00.04');
                    this.socket.send('WEB GUI :V2.01');
                },
            },
            {
                name: 'getRoute',
                regExp: /r av out (\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.socket.send(`input ${this.videoOutputs[output]} -> output ${match[1]})`);
                },
            },
            {
                name: 'setRoute',
                regExp: /s in (\d+) av out (\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[2], 10);
                    this.videoOutputs[output] = match[1];
                    this.socket.send(`input ${this.videoOutputs[output]} -> output ${output})`);
                },
            },
            {
                name: 'powerSet',
                regExp: /s power (\d)!/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /r power!/i,
                callback: (match) => {
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
        ];
    }
}
AlfatronMuheGen2.emulatorType = 'socketEmulator';
AlfatronMuheGen2.key = '-NFEUdp98b8A04jn3nAx';
